import Name from '../';
import { createSelectors } from '../../helpers';

const props = ['serverError'];

export const [getServerError] = createSelectors(Name, props);
